import { Component, Input} from '@angular/core';
import { Store } from '@ngxs/store';
import { TicketCommentsBaseComponent } from './ticket-comments.component.base';
import { Attachment, TicketComment } from 'wms-lib';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'app-ticket-comments',
  templateUrl: './ticket-comments.component.html',
  styleUrls: ['./ticket-comments.component.scss']
})
export class TicketCommentsComponent extends TicketCommentsBaseComponent {
  @Input() read_only: boolean = false;
  constructor(store: Store, private confirmationService: ConfirmationService) {
    super(store);
  }

  onSelectFiles(event: any) {
    const target: DataTransfer = <DataTransfer>(event.target);
    for (let i = 0; i < target.files.length; i++) {
      this.attachments.push(new Attachment({
        file: target.files[i],
        filename: target.files[i].name
      }));
    }
  }

  openAttachmentPanel(event: Event, overlayPanel: any, comment?: TicketComment) {
    this.setWorkingComment(comment);
    overlayPanel.toggle(event);
  }


  removeSelectedFile(index: number, comment?: TicketComment) {
    const a = this.listAttachments[index];
    if (a.stored) {
      this.confirmationService.confirm({
        message: 'Are you sure you want to delete this file?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
          this.deleteStoredFile(a, comment);
        }
      });
    } else {
      this.listAttachments.splice(index, 1);
    }
  }

  deleteStoredFile(a: Attachment, comment?: TicketComment) {
    const attachment = comment ? comment.attachments?.find(att => att.id === a.id) : this.attachments.find(att => att.id === a.id);
    if (!attachment) return;
    this.ticket.commentAttachments.find(att => att.id === a.id)._destroy = true;
    this.saveTicket(this.ticket);
  }

  getAttachmentButtonLabel(): string {
    if (!this.attachments || this.attachments.length === 0) {
      return 'Attachments';
    }
    return `${this.attachments.length} file${this.attachments.length !== 1 ? 's' : ''}`;
  }

  setWorkingComment(comment: TicketComment | undefined) {
    this.workingComment = comment;
  }

  downloadAttachment(attachment: Attachment) {
    const link = document.createElement('a');
    link.href = attachment.src as string;
    link.target = '_blank';
    link.download = attachment.filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  get listAttachments(): Attachment[] {
    if (this.workingComment && this.workingComment.attachments) {
      return this.workingComment.attachments;
    }
    return this.attachments;
  }

}
